// src/utils/models/salesInvoiceModel.js
// Factura de VENTA (emitida a cliente)

export const SALES_INVOICE_STATUS = {
  UNPAID: "unpaid",
  PAID: "paid",
};

export const SALES_INVOICE_STATUS_LABELS = {
  unpaid: "Sin pagar",
  paid: "Pagada",
};

export const PAYMENT_METHODS = {
  TRANSFER: "transfer",
  CASH: "cash",
};

export const PAYMENT_METHOD_LABELS = {
  transfer: "Transferencia",
  cash: "Al contado",
};

export const createSalesInvoice = (data) => ({
  id: "",

  // Número de factura
  invoiceNumber: data.invoiceNumber || "",

  // Cliente (receptor)
  clientId: data.clientId || "",
  clientName: data.clientName || "",
  clientTaxId: data.clientTaxId || "",
  clientEmail: data.clientEmail || "",
  clientAddress: data.clientAddress || "",

  // Emisor (EPC)
  issuerName: data.issuerName || "EPC Development & Management, S.L.",
  issuerTaxId: data.issuerTaxId || "B26623850",
  issuerAddress: data.issuerAddress || "C/ Juan de Austria 13, Cox, Alicante",

  // Importes
  baseAmount: data.baseAmount || 0,
  taxRate: data.taxRate || 21,
  taxAmount: data.taxAmount || 0,
  total: data.total || 0,

  // Proyectos asociados
  projects: data.projects || [],

  // Fechas
  issueDate: data.issueDate || new Date().toISOString(),
  dueDate: data.dueDate || "",

  // Forma de cobro
  paymentMethod: data.paymentMethod || PAYMENT_METHODS.TRANSFER,
  iban: data.iban || "ES31 0182 4428 1602 0155 9169",

  // Estado - Por defecto SIN PAGAR
  status: data.status || SALES_INVOICE_STATUS.UNPAID,

  // Estado de subida al Drive
  uploadedToDrive: data.uploadedToDrive || false,
  uploadedToDriveAt: data.uploadedToDriveAt || null,

  // Archivos adjuntos
  files: data.files || [],

  // Metadata
  notes: data.notes || "",
  paidAt: null,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  createdBy: "",
  isActive: true,
});
